import i18n from '@/lib/i18n';
import { languageToCountryFlag } from '@/lib/utils';
import { Preferences } from '@capacitor/preferences';
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonTitle,
  IonToolbar
} from '@ionic/react';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { AppConfig, type SupportedLocale } from '../utils/AppConfig';
import './LocaleSelect.css';

type LocaleSelectProps = {
  iconsOnly?: boolean;
};

const LocaleSettings: React.FC<LocaleSelectProps> = ({ }) => {
  const [selectedLocale, setSelectedLocale] = useState<SupportedLocale>('en'); // Default locale

  useEffect(() => {
    setSelectedLocale(i18n.language as SupportedLocale); // Set the locale in state
  }, [i18n]);

  const handleLocaleChange = async (event: CustomEvent) => {
    await Preferences.set({ key: 'locale', value: event.detail.value });
    setSelectedLocale(event.detail.value as SupportedLocale);
    i18n.changeLanguage(event.detail.value as SupportedLocale);
  };

  return (
    <>
      <IonHeader>
        <IonToolbar className="md:hidden">
          <IonButtons slot="start">
            <IonBackButton text={t('back')} defaultHref="/settings" />
          </IonButtons>
          <IonTitle>{t('languages')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList lines="none">
          <h1 className="text-3xl font-bold pt-6 hidden md:block">{t('languages')}</h1>
          <IonRadioGroup value={selectedLocale} onIonChange={handleLocaleChange} className="grid md:grid-cols-2 gap-3 m-2">
            {Object.entries(AppConfig.languageLabels).map(([key, value]) => (
              <IonItem key={key} color="transparent" className='border border-input'>
                <IonRadio slot='start' labelPlacement="start" key={key} value={key}>
                  <div className='flex items-center'>
                    <img
                      alt={key}
                      src={`/assets/images/flags/${languageToCountryFlag(key)}.svg`}
                      className="mr-2 w-8 h-6 rounded"
                    />
                    {value}
                  </div>
                </IonRadio>
              </IonItem>
            ))}
          </IonRadioGroup>
        </IonList>
      </IonContent>
    </>
  );
};

export default LocaleSettings;
